import {BaseContainerModel} from '../base-container.model';
import {app_login_cfg_RowClass} from '../../dbschema/app_login_cfg.model';

export class AppLoginConfigContainerModel extends BaseContainerModel {
  app_login_cfg: app_login_cfg_RowClass = new app_login_cfg_RowClass();
}
